import { render, staticRenderFns } from "./design-a-video-game.vue?vue&type=template&id=55430b4d&"
import script from "./design-a-video-game.vue?vue&type=script&lang=js&"
export * from "./design-a-video-game.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports